import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  isOpen: true, // Default to open on desktop
  isMobile: false,
  // The desktop preference, parked while the viewport is narrow.
  wasOpenOnDesktop: true,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    // Each of these mirrors the choice into wasOpenOnDesktop while on desktop,
    // so a deliberate collapse survives a trip through mobile width.
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
      if (!state.isMobile) state.wasOpenOnDesktop = state.isOpen;
    },
    openSidebar: (state) => {
      state.isOpen = true;
      if (!state.isMobile) state.wasOpenOnDesktop = true;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
      if (!state.isMobile) state.wasOpenOnDesktop = false;
    },
    /**
     * Crossing the mobile breakpoint.
     *
     * Only acts on an actual transition. The previous version closed the panel
     * on every call where the payload was true, and never reopened it on the
     * way back — so narrowing the window below 768px and widening it again
     * left the sidebar collapsed to unlabelled icons for the rest of the
     * session, with no indication that it could be reopened.
     */
    setMobileMode: (state, action) => {
      const nowMobile = action.payload;
      if (nowMobile === state.isMobile) return;

      if (nowMobile) {
        // Remember how the panel sat on desktop so returning restores it.
        state.wasOpenOnDesktop = state.isOpen;
        state.isOpen = false;
      } else {
        state.isOpen = state.wasOpenOnDesktop ?? true;
      }

      state.isMobile = nowMobile;
    },
  },
});

// Action creators
export const { toggleSidebar, openSidebar, closeSidebar, setMobileMode } = sidebarSlice.actions;

// Selectors
export const selectSidebarState = (state) => state.sidebar;
export const selectIsOpen = (state) => state.sidebar.isOpen;
export const selectIsMobile = (state) => state.sidebar.isMobile;

export default sidebarSlice.reducer;
